export default __webpack_public_path__ + "static/media/mule-deer@2x.5ba8876f.jpg";